import { render } from "./CustomImageUploader.vue?vue&type=template&id=deab2556&scoped=true"
import script from "./CustomImageUploader.vue?vue&type=script&lang=js"
export * from "./CustomImageUploader.vue?vue&type=script&lang=js"

import "./CustomImageUploader.vue?vue&type=style&index=0&id=deab2556&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deab2556"]])

export default __exports__